// 青波線用ツールチップ（言い換え候補選択）
//
// Phase 1 の tooltip.js とほぼ同じ DOM 配置だが、複数候補（最大3つ）を
// ボタンとして並べる点が異なる。クリックで採用 → applySuggestion。

let tooltipEl = null;
let currentContext = null;
let outsideClickHandler = null;
let keydownHandler = null;

function ensureTooltip() {
  if (tooltipEl) return tooltipEl;
  tooltipEl = document.createElement("div");
  tooltipEl.className = "proofread-tooltip proofread-blue-tooltip";
  tooltipEl.setAttribute("role", "dialog");
  tooltipEl.style.display = "none";
  // モバイルでツールチップ内ボタンをタップした際に textarea の
  // blur が発生してソフトキーボードが閉じるのを防ぐ。
  tooltipEl.addEventListener("mousedown", (e) => {
    e.preventDefault();
  });
  document.body.appendChild(tooltipEl);
  return tooltipEl;
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function buildHtml(suggestion) {
  const reason = suggestion.reason || "より自然な表現に言い換えできるかも？";
  const original = suggestion.original || "";
  const candidates = Array.isArray(suggestion.candidates) ? suggestion.candidates : [];

  const candidatesHtml = candidates.map((c, i) => `
    <button type="button" class="proofread-tooltip__apply" data-cand-idx="${i}">
      <span class="proofread-tooltip__apply-text">${escapeHtml(c)}</span>
      <span class="proofread-tooltip__apply-hint">クリックで置き換え</span>
    </button>
  `).join("");

  return `
    <div class="proofread-tooltip__reason">${escapeHtml(reason)}</div>
    ${original ? `<div class="proofread-blue-tooltip__original">元: <span>${escapeHtml(original)}</span></div>` : ""}
    <div class="proofread-blue-tooltip__suggestion-label">こう直すのはどう？</div>
    ${candidatesHtml}
    <div class="proofread-tooltip__actions">
      <button type="button" class="proofread-tooltip__ignore">このままにする</button>
    </div>
  `;
}

function position(anchor) {
  const tip = tooltipEl;
  const rect = anchor.getBoundingClientRect();
  const tipRect = tip.getBoundingClientRect();
  const margin = 8;

  let top = rect.bottom + window.scrollY + margin;
  let left = rect.left + window.scrollX;

  const vw = document.documentElement.clientWidth;
  if (left + tipRect.width > vw - margin) {
    left = Math.max(margin, vw - tipRect.width - margin);
  }

  tip.style.top = `${top}px`;
  tip.style.left = `${left}px`;
}

function attachGlobalListeners() {
  outsideClickHandler = (e) => {
    if (!tooltipEl) return;
    if (tooltipEl.contains(e.target)) return;
    hideBlueTooltip();
  };
  keydownHandler = (e) => {
    if (e.key === "Escape") hideBlueTooltip();
  };
  document.addEventListener("mousedown", outsideClickHandler, true);
  document.addEventListener("keydown", keydownHandler, true);
}

function detachGlobalListeners() {
  if (outsideClickHandler) {
    document.removeEventListener("mousedown", outsideClickHandler, true);
    outsideClickHandler = null;
  }
  if (keydownHandler) {
    document.removeEventListener("keydown", keydownHandler, true);
    keydownHandler = null;
  }
}

/**
 * 青波線ツールチップを表示する。
 *
 * @param {object} suggestion  { original, range, candidates, reason }
 * @param {HTMLElement} anchor  クリックされたマーク要素
 * @param {HTMLTextAreaElement} textarea
 * @param {object} callbacks
 * @param {(candidate: string) => void} callbacks.onApply  候補採用時
 * @param {() => void} callbacks.onDismiss                 「このままにする」時
 */
export function showBlueTooltip(suggestion, anchor, textarea, callbacks) {
  hideBlueTooltip();

  const tip = ensureTooltip();
  currentContext = { suggestion, textarea, callbacks };

  tip.innerHTML = buildHtml(suggestion);
  tip.style.display = "block";
  position(anchor);

  // 候補ボタン配線
  const candidates = Array.isArray(suggestion.candidates) ? suggestion.candidates : [];
  const applyBtns = tip.querySelectorAll(".proofread-tooltip__apply");
  applyBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const idx = parseInt(btn.getAttribute("data-cand-idx"), 10);
      const candidate = candidates[idx];
      if (typeof candidate === "string" && callbacks && typeof callbacks.onApply === "function") {
        // idx = どの言い換え候補を選んだか（採用イベントの candidate_index に使う）
        callbacks.onApply(candidate, idx);
      }
    });
  });

  const ignoreBtn = tip.querySelector(".proofread-tooltip__ignore");
  if (ignoreBtn) {
    ignoreBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      if (callbacks && typeof callbacks.onDismiss === "function") {
        callbacks.onDismiss();
      }
      hideBlueTooltip();
    });
  }

  if (!outsideClickHandler) attachGlobalListeners();
}

export function hideBlueTooltip() {
  if (tooltipEl) {
    tooltipEl.style.display = "none";
    tooltipEl.innerHTML = "";
  }
  currentContext = null;
  detachGlobalListeners();
}
